module.exports = __webpack_public_path__ + "static/media/404_error.c41d2775.png";